class FilterService {

    syncFilters = (key, value, filterList, clientList) => {
        if(key === 'location'){
            filterList.client = null;
            filterList.bu = null;
        }
        if(key === 'client'){
            filterList.bu = null;
            filterList.location = value.location;
        }
        if(key === 'bu'){
            filterList.client = clientList.find(client => client.id === value.idClient);
            filterList.location = value.location;
        }
        return filterList;
    }
}

export default new FilterService();


// WEBPACK FOOTER //
// ./src/services/FilterService.js